import { Stack } from "@mui/material";
import { type ReactNode } from "react";

import { Illustration, type IllustrationType } from "../Illustration";
import { Text } from "../Text";
import { Title } from "../Title";

export interface BottomSheetIllustrationContentProps {
  illustrationType: IllustrationType;
  title: ReactNode;
  description?: ReactNode;
  /**
   * Determines the top padding of the Content:
   * `hasHeader = true` -> less padding (5)
   * `hasHeader = false (default)` -> more padding (11)
   */
  hasHeader?: boolean;
  /**
   * Determines the bottom padding of the Content:
   * `hasFooter = true` -> less padding (5)
   * `hasFooter = false (default)` -> more padding (11)
   */
  hasFooter?: boolean;
}

export function BottomSheetIllustrationContent(props: BottomSheetIllustrationContentProps) {
  const { illustrationType, title, description, hasHeader, hasFooter } = props;

  return (
    <Stack
      spacing={11}
      sx={{
        paddingTop: hasHeader ? 5 : 11,
        paddingBottom: hasFooter ? 5 : 11,
        paddingX: 5,
      }}
    >
      <Stack spacing={7} justifyContent="center" alignItems="center" sx={{ textAlign: "center" }}>
        <Illustration type={illustrationType} />

        <Title component="h2" sx={{ textWrap: "balance" }}>
          {title}
        </Title>

        {description && (
          <Text semibold variant="body1" sx={(theme) => ({ color: theme.palette.text.secondary })}>
            {description}
          </Text>
        )}
      </Stack>
    </Stack>
  );
}
